import {ReactNode} from "react";

export type AlertDetail = {
    title?: string;
    caption?: string | ReactNode;
    message: string | ReactNode;
    type: 'ALERT' | 'CONFIRM';
    callback?: any;
    confirmBtnTxt?: string;
}

export type ToastDetail = {
    message: string;
}

export const eAlert = (message: string | ReactNode, caption?: string | ReactNode, title?: string) => {
    const doAlert = (detail: AlertDetail) => {
        window.dispatchEvent(
            new CustomEvent("eAlert", {
                detail,
            })
        );
    }
    doAlert({title, caption, message, type: 'ALERT'});
};

export const eConfirm = (message: string | ReactNode, callback: any, caption?: string | ReactNode, title?: string, confirmBtnTxt?: string) => {
    const doConfirm = (detail: AlertDetail) => {
        window.dispatchEvent(
            new CustomEvent("eAlert", {
                detail,
            })
        );
    }
    doConfirm({title, caption, message, type: 'CONFIRM', callback, confirmBtnTxt});
}

export const eToast = (message: string) => {
    const doToast = (detail: ToastDetail) => {
        window.dispatchEvent(
            new CustomEvent("eToast", {
                detail,
            })
        );
    };
    doToast({message});
};